// extracted by mini-css-extract-plugin
module.exports = {"selectedService":"Service_selectedService__8cHGR","selectServiceText":"Service_selectServiceText__2vtdZ"};